import React from "react";

import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";

import getDates from "../../../shared/services/date.service";

import styles from "./reportHistoryContentItem.module.scss";

const ReportHistoryContentItem = (props) => {
  const { data } = props;
  const { cars, reports, reportStartDate, currentDate, reportEndDate } = data;

  if (!cars) return null;

  let reportsTitle = reports.length > 1 ? reports.map((item) => item.title).join(", ") : reports[0].title;

  return (
    <div className={styles.reportHistoryItem}>
      <div className={styles.reportHistoryItemInner} onClick={!!props.clickItem ? props.clickItem.bind(this) : null}>
        <span className={styles.reportType}>
          {reportsTitle}
          <span className={styles.reportDate}>
            {` ${getDates.getDateFormat2(currentDate)} в ${getDates.getTimeFormat2(currentDate)}`}
          </span>
          <div className={styles["infoItem_datesInfo"]} style={{ paddingRight: "10px", fontWeight: "500" }}>
            {`${getDates.getDateFormat2(reportStartDate)} ${getDates.getTimeFormat1(reportStartDate)} - 
                  ${getDates.getDateFormat2(reportEndDate)} ${getDates.getTimeFormat1(reportEndDate)}`}
          </div>
        </span>

        <div className={styles.historyItemCarsList}>
          {cars.map((item) => [<div key={item.id} className={styles["infoItem_carInfo"]}>{`${item.title}, ${item.registerNumber}`}</div>])}
        </div>
      </div>
      <div className={styles.closeWrapper}>
        <span className="icon-x" onClick={props.deleteReport}></span>
      </div>
    </div>
  );
};

export default React.memo(ReportHistoryContentItem);
